"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveTheme = exports.applyTheme = exports.getPreferredTheme = exports.THEMES = void 0;
const common_1 = require("@/components/common");
const constants_1 = require("@/constants");
const storage_1 = require("@/utils/storage");
exports.THEMES = [
    { value: 'light', icon: common_1.ICON_NAMES.LIGHT_MODE, label: 'Day' },
    { value: 'dark', icon: common_1.ICON_NAMES.DARK_MODE, label: 'Night' },
    { value: 'brutal', icon: common_1.ICON_NAMES.BRUTAL_MODE, label: 'Brutal' },
    { value: 'glass', icon: common_1.ICON_NAMES.GLASS_MODE, label: 'Glass' },
];
const DEFAULT_THEME = 'light';
function isTheme(value) {
    return exports.THEMES.some(theme => theme.value === value);
}
function getStoredTheme() {
    const theme = (0, storage_1.readStorage)(constants_1.THEME_STORAGE_KEY);
    return isTheme(theme) ? theme : null;
}
// 시스템 설정(prefers-color-scheme)에 따른 다크모드는 일단 적용하지 않는다.
// function getSystemTheme(): Theme {
//   return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : DEFAULT_THEME
// }
function getPreferredTheme() {
    return getStoredTheme() ?? DEFAULT_THEME;
}
exports.getPreferredTheme = getPreferredTheme;
function applyTheme(theme = getPreferredTheme()) {
    document.body.dataset.theme = theme;
    return theme;
}
exports.applyTheme = applyTheme;
function saveTheme(theme) {
    (0, storage_1.writeStorage)(constants_1.THEME_STORAGE_KEY, theme);
    return applyTheme(theme);
}
exports.saveTheme = saveTheme;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGhlbWUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ0aGVtZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxnREFBK0Q7QUFDL0QsMkNBQStDO0FBQy9DLDZDQUEyRDtBQUk5QyxRQUFBLE1BQU0sR0FBc0Q7SUFDdkUsRUFBRSxLQUFLLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxtQkFBVSxDQUFDLFVBQVUsRUFBRSxLQUFLLEVBQUUsS0FBSyxFQUFFO0lBQzdELEVBQUUsS0FBSyxFQUFFLE1BQU0sRUFBRSxJQUFJLEVBQUUsbUJBQVUsQ0FBQyxTQUFTLEVBQUUsS0FBSyxFQUFFLE9BQU8sRUFBRTtJQUM3RCxFQUFFLEtBQUssRUFBRSxRQUFRLEVBQUUsSUFBSSxFQUFFLG1CQUFVLENBQUMsV0FBVyxFQUFFLEtBQUssRUFBRSxRQUFRLEVBQUU7SUFDbEUsRUFBRSxLQUFLLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxtQkFBVSxDQUFDLFVBQVUsRUFBRSxLQUFLLEVBQUUsT0FBTyxFQUFFO0NBQ2hFLENBQUE7QUFFRCxNQUFNLGFBQWEsR0FBVSxPQUFPLENBQUE7QUFFcEMsU0FBUyxPQUFPLENBQUMsS0FBb0I7SUFDbkMsT0FBTyxjQUFNLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUMsS0FBSyxDQUFDLEtBQUssS0FBSyxLQUFLLENBQUMsQ0FBQTtBQUNwRCxDQUFDO0FBRUQsU0FBUyxjQUFjO0lBQ3JCLE1BQU0sS0FBSyxHQUFHLElBQUEscUJBQVcsRUFBQyw2QkFBaUIsQ0FBQyxDQUFBO0lBQzVDLE9BQU8sT0FBTyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQTtBQUN0QyxDQUFDO0FBRUQsc0RBQXNEO0FBQ3RELHFDQUFxQztBQUNyQyw4RkFBOEY7QUFDOUYsSUFBSTtBQUVKLFNBQWdCLGlCQUFpQjtJQUMvQixPQUFPLGNBQWMsRUFBRSxJQUFJLGFBQWEsQ0FBQTtBQUMxQyxDQUFDO0FBRkQsOENBRUM7QUFFRCxTQUFnQixVQUFVLENBQUMsS0FBSyxHQUFHLGlCQUFpQixFQUFFO0lBQ3BELFFBQVEsQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUE7SUFDbkMsT0FBTyxLQUFLLENBQUE7QUFDZCxDQUFDO0FBSEQsZ0NBR0M7QUFFRCxTQUFnQixTQUFTLENBQUMsS0FBWTtJQUNwQyxJQUFBLHNCQUFZLEVBQUMsNkJBQWlCLEVBQUUsS0FBSyxDQUFDLENBQUE7SUFDdEMsT0FBTyxVQUFVLENBQUMsS0FBSyxDQUFDLENBQUE7QUFDMUIsQ0FBQztBQUhELDhCQUdDIn0=